<template>
	<p class="text-xs-center title">Logging out...</p>
</template>

<script>

	import VueCookies from 'vue-cookies';

	export default {

		mounted : function(){
			VueCookies.remove(this.cookieKey);
			setTimeout(() => {
				this.$router.push('/login');
			}, 500);
		}

	};
</script>